import React, { useRef } from 'react';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import PropTypes from 'prop-types';
import Tooltip from 'cccisd-tooltip';
import notification from 'cccisd-notification';
import CaregiverForm from '../../../../components/Manage/CaregiverForm';

import IconPencil from 'cccisd-icons/pencil';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const EditGroupForm = props => {
    const modal = useRef();

    // rows are coming from each role's caregiver_tableMain.graphql
    const { row, loadData } = props;

    const onSubmit = async values => {
        const response = await axios.put(
            Boilerplate.route('api.nexus.pawn.update', {
                pawn: row['pawn.pawnId'],
            }),
            {
                pawnHash: row['pawn.pawnHash'],
                firstName: values.firstName,
                lastName: values.lastName,
                wrapId: values.wrapId,
                phoneNumber: values.phoneNumber,
                language: values.language || 'en',
                parentPawns: values.careCoordinatorId,
                group: values.site,
                role: 'caregiver',
            }
        );

        if (response.data.errors) {
            return Promise.reject(response.data.errors);
        }
        await loadData();
        notification('Caregiver edited.');
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <Tooltip title="Edit">
                    <button type="button" className="btn btn-xs btn-success">
                        <IconPencil />
                    </button>
                </Tooltip>
            }
            title="Edit Caregiver"
        >
            <CaregiverForm
                onSubmit={onSubmit}
                initialValues={{
                    wrapId: row['fields.wrapId'],
                    firstName: row['fields.firstName'],
                    lastName: row['fields.lastName'],
                    phoneNumber: row['fields.phoneNumber'],
                    language: row['fields.language'] || 'en',
                    site: [row['parentGroup.site.group.groupId']],
                    careCoordinator: [row['parentRoles.careCoordinator.pawn.pawnId']],
                }}
                {...props}
            />
        </Modal>
    );
};

EditGroupForm.propTypes = {
    loadData: PropTypes.func,
    row: PropTypes.object,
};

export default EditGroupForm;
